import { render, staticRenderFns } from "./CustomButtons.vue?vue&type=template&id=6fd16ce7&scoped=true&"
import script from "./CustomButtons.vue?vue&type=script&lang=ts&"
export * from "./CustomButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd16ce7",
  null
  
)

export default component.exports